import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';
import { daysOfWeekMap } from '../../constants';

const addToCartItem = async (pricingId: number, childId: number, selectedDaysArray?: string[]) => {
    let arrayResponse = {
        success: false,
        message: 'Failed to add item to cart.',
    };

    let payload: { [key: string]: any } = { childId };

    if (selectedDaysArray) {
        Object.values(daysOfWeekMap).forEach(day => payload[day] = false);
        selectedDaysArray.forEach(day => {
            const dayKey = daysOfWeekMap[day as keyof typeof daysOfWeekMap];
            payload[dayKey] = true;
        });
    }

    try {
        const response = await eventsRequest(`/cart/item/${pricingId}`, 'post', payload);

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            arrayResponse.message = 'Item added to cart.';
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
};

export default addToCartItem;
